/* eslint-disable max-len */
import * as React from 'react';

const SvgComponent = (props) => (
  <svg height={15} viewBox="0 0 850 500" width={23.077} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0h868.11v496.06H0z" fill="#fff" fillRule="evenodd" />
    <path
      d="M332.399 266.381c.071-.095 3.292-5.733 2.909-4.825 1.485 1.137 4.195.06 2.23-2.498.477-1.034 1.078-1.823 1.56-2.857 1.078-2.022-1.234-2.894-2.151-1.496-.56 1.071-1.101 1.71-1.662 2.782-2.917-1.384-3.104 1.872-1.71 2.44-.62.875-1.673 2.32-2.293 3.197l1.117 3.257z"
      fill="#9c4314"
      fillRule="evenodd"
    />
    <path
      d="M332.011 265.12c-.094-.07-5.777-3.21-4.864-2.842 1.117-1.499 0-4.194-2.53-2.19-1.04-.466-1.838-1.06-2.879-1.523-2.037-1.048-2.88 1.275-1.466 2.173 1.083.544 1.725 1.074 2.804 1.62-1.342 2.935 1.917 3.08 2.466 1.678.887.606 4.315 2.594 5.203 3.201 1.078-.387.188-1.73 1.266-2.116zM352.573 299.575c.019-.118.166-6.61.263-5.63 1.846.294 3.714-1.944.767-3.256-.071-1.137.083-2.118.011-3.256-.015-2.294-2.466-1.959-2.6-.292.018 1.21-.155 2.027-.136 3.237-3.225.172-1.842 3.126-.346 2.961-.124 1.066-.365 2.838-.492 3.904.845.777 1.687 1.555 2.533 2.332z"
      fill="#9c4314"
      fillRule="evenodd"
    />
    <path
      d="M351.633 298.65c-.116-.017-6.612-.071-5.63-.182.266-1.85-1.997-3.687-3.267-.722-1.14.087-2.12-.054-3.255.034-2.297.046-1.925 2.492-.256 2.607 1.207-.036 2.026.124 3.236.089.218 3.22 3.154 1.797 2.966.301l5.466.572c.767-.854-.023-1.844.74-2.699z"
      fill="#9c4314"
      fillRule="evenodd"
    />
    <path
      d="M418.822 320.907s2.225 3.006 3.229 3.117c3.116.223 27.839 0 27.839 0 0-.037.887-.52.887-.556.82-1.04.744-1.634 1.56-2.673 1.3-1.3 3.154-1.707 4.454-3.007 5.567-1.336 10.578-2.672 16.15-3.563-.448-3.303-3.79-2.598-5.572-3.897-.556-.52-.443-1.04-.109-1.56l12.36-5.678v-1.336c-8.762 1.04-16.852 2.746-26.28 3.117-10.728 4.418-21.456 8.834-32.18 13.252-.782.928-1.56 1.855-2.338 2.784z"
      fill="#42b2f3"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path d="M329.85 261.778h-.113c.56 0 .117.037 0-1.337" fill="none" stroke="#000" strokeWidth=".3759pt" />
    <path
      d="M330.327 263.258c-1.669-5.903-4.371-11.072-10.668-12.601-1.18-.271-2.022-3.643-.052-3.485 1.112.443.022-.21 1.135.233 1.101.395 2.82-.474 2.112-2.353 0-.222-2.105-3.955-2.105-4.064-.39-.428.339-2.819 2.23-1.56.89.587 1.781 1.959 3.067 2.226.47-.075.782-1.545.703-2.68 0-.11.113-3.846.113-3.846-.448-2.255 1.545-3.402 3.146-1.718.109.557-.015.56.098 1.12.364.745.812.861 1.334.11.707-.704 1.41-1.41 2.116-2.117 1.256-.466 2.041-.932 2.117 1.673 0 0-1.733 2.173-2.553 2.958-.428.632-1.353 1.489.256 1.959.109 0 2.297.315 2.297.315 1.496.624 1.654 2.267.552 2.417 0 0-1.169 1.361-3.214 2.496-.631.508-1.15 1.113-.597 1.808 1.18.46.804.02 2.819.02 1.699-.392 1.541 3.77-1.53 3.488-.917.218-2.131.127-2.628 1.597-.225 1.143-.278 3.338-.278 3.895-.191 2.653.2 6.328.2 6.44.221 1.892-.448 1.224-.67 1.67zM348.555 297.215c-.218-.277-5.797-6.392-12.243-5.705-1.203.146-3.132-2.746-1.226-3.263 1.2.044.267-.127 1.462-.084 1.015-.71-.815-2.897-1.646-2.138-.071-.21-2.206.457-3.112.273-2.8-.268-4.026-3.398-1.978-4.584 1.27.486 3.677.53 4.977.351 1.286-.391.692-1.562-.556-1.736-1.77-.263-8.92-2.005-8.289-2.872-1.184-1.97-.01-3.487 2.064-2.441 1.714 1.038 1.913.455 1.496-.32-.507-1.472-.996-1.119-1.071-2.397-.124-.823.143-1.567 1.357-1.05.511-.43 1.357 2.652 4.54 1.483.587.492 1.09-3.335 3.297-2.753 1.658.512.527 2.234.85 4.665.263 1.602 1.864 1.234 2.086.403-.35-3.68 3.248-3.744 3.658-2.5.342.908.65 3.383.214 5.709-.237 1.183-.049 3.53.707 3.998 1.266.033.447-.254 1.319-1.565 1.466-.944 3.748 2.475 1.079 4.193-2.816.607 1.594 11.337 1.966 11.936-.406.44-.891-.097-.951.397z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#286726"
      strokeWidth={1.7385375}
    />
    <path
      d="M383.145 325.918c0-.12-.872-6.554-.62-5.601 1.868 0 3.364-2.503.248-3.337-.248-1.112-.248-2.105-.5-3.217-.372-2.264-2.74-1.55-2.616.118.21 1.192.165 2.027.376 3.219-3.158.675-1.331 3.376.124 2.978.041 1.073.082 2.86.124 3.933l2.864 1.907z"
      fill="#9c4314"
      fillRule="evenodd"
    />
    <path
      d="M383.032 325.159c-.12.001-6.54.965-5.59.702-.026-1.869-2.552-3.329-3.341-.202-1.109.265-2.101.28-3.21.544-2.26.406-1.511 2.763.158 2.615 1.187-.224 2.022-.195 3.21-.42.722 3.148 3.394 1.282 2.977-.166l5.488-.292c.624-.964-.312-1.817.308-2.781z"
      fill="#9c4314"
      fillRule="evenodd"
    />
    <path
      d="M380.84 289.968c15.717 9.278 19.758 7.93 19.1 3.82.756 0 .917.656 3.15-.988-.312 6.078 6.308 9.573 10.341 8.84 3.643.235 3.173 5.05 3.173 5.05.222 4.927-1.436 6.918-1.214 11.845-.057 0-.113-.587-.17-.587-4.476-1.065-13.302-1.191-16.607-1.904 15.15-10.335-11.653-10.618-14.047-10.97-1.812-.235-.519-1.997.537-2.467 8.338-1.644-7.837-9.54-7.416-10.48-.989-.587.068-1.057.068-1.057 1.109-.72 1.98-.382 3.086-1.102z"
      fill="#33b1e9"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9867375}
    />
    <path
      d="M420.089 297.83a4.92 4.92 0 0 0-4.932 4.932c-.824 3.758-.707 9.043 0 14.093a4.921 4.921 0 0 0 4.932 4.932c10.882 1.174 22.587.822 32.646 0 2.733 0 4.936-2.2 4.936-4.932 1.29-4.463.936-9.16 0-14.093a4.924 4.924 0 0 0-4.936-4.933c-10.882-.47-22.001-1.057-32.646 0z"
      fill="#983d25"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.4096250000000001}
    />
    <path
      d="m383.33 163.677-7.451 6.45c-3.06 1.354-6.387 3.038-3.992 10.244-1.395 9.247 6.056 10.71 12.574 8.78 1.082-2.394 1.428-4.048 2.514-6.442-2.883-.444-4.424.567-7.04.387-1.797-.286-1.928-1.639-1.263-2.526 2.815-1.395 5.364-2.725 8.18-4.124-.064-.42-.132-.109-.2-.53-2.327 1.196-3.988 1.594-6.45 2.594-1.951.688-2.504-1.82-1.73-2.928 0 0 5.056-7.251 5.056-7.315.421-1.526.128-4.094-.199-4.59z"
      fill="#268728"
      fillRule="evenodd"
      stroke="#000003"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M404.154 290.423a3.903 3.903 0 1 0-7.804 0 3.903 3.903 0 1 0 7.804 0h-3.902z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M385.643 305.143a3.68 3.68 0 1 0-7.357 0 3.68 3.68 0 1 0 7.357 0h-3.679z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9395674199999999}
    />
    <path
      d="M477.081 313.394a3.68 3.68 0 1 0-7.358 0 3.68 3.68 0 1 0 7.358 0h-3.679z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9303525}
    />
    <path
      d="M383.683 168.594c.09 2.214.15 4.992.15 5.841-.094-2.07-.82-3.729-1.09-4.54.323-.534.846-1.301.94-1.301z"
      fill="#ba4600"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth=".3759pt"
    />
    <path
      d="M419.768 317.856a3.68 3.68 0 1 0-7.358 0 3.68 3.68 0 1 0 7.358 0h-3.68zM458.572 317.856a3.68 3.68 0 1 0-7.358 0 3.68 3.68 0 1 0 7.358 0h-3.68zM458.572 300.012a3.68 3.68 0 1 0-7.358 0 3.68 3.68 0 1 0 7.358 0h-3.68zM419.99 300.012a3.68 3.68 0 1 0-7.358 0 3.68 3.68 0 1 0 7.357 0h-3.679z"
      fill="#973100"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.3531755600000002}
    />
    <path
      d="M383.694 327.914c-.218-.277-1.868-4.961-11.21-5.165-1.315-.077-2.15.301-4.811.117-1.541.126-.936-1.711-.323-2.373 1.01-.71-3.609-.364-5.199-.175-1.601-.093-2.68-.365-3.586-.55-2.8-.268-4.44-2.235-2.395-3.421.861-.843 4.346.115 5.646-.064 1.286-.392 1.106-2.558-.142-2.733-1.77-.263-9.503-.842-8.872-1.71-1.18-1.968-.838-2.988 2.233-2.607 1.71 1.039 1.662-.292 1.244-1.066-.507-1.472-3.319-1.7-3.394-2.978-.458-3.066 1.553-3.478 2.767-2.96.515-.432-2.297-2.83.887-3.998.79-.249 2.417-.055 2.966 2.852 1.657.512.51-1.908 2.759-2.892 1.924-.807-.128 8.625 2.169 8.54 1.977.806 1.586-5.154 3.244-3.995 3.578-.918 1.845 11.44 3.405 10.694 2.587 2.262 2.857-2.034 3.613-1.566 1.263.033 2.109.078 1.402 2.92-.526 2.211.26 2.724.662 3.61 2.42 5.332 6.052 5.282 7.262 7.736.39 3.628-.267 1.29-.327 1.785z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#286726"
      strokeWidth={1.7385375}
    />
    <path
      d="M428.426 336.115c-4.466 3.671-9.104 6.047-10.803 9.866 2.033-.274 2.819-.616 4.337-.425 1.647-3.68 6.82-5.642 9.872-8.62-1.136-.274-2.27-.548-3.406-.82zM440.372 336.508c4.041 3.73 9.044 5.86 10.807 9.804-2.037-.275-2.887-.553-4.1-.24-1.644-3.677-7.06-5.827-10.113-8.804 1.136-.271 2.27-.485 3.406-.76z"
      fill="#009400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M437.32 337.268c4.894 2.94 6.845 5.052 9.86 8.81-1.448.087-3.481.741-4.222 1.174-3.642-4.737-6.461-6.42-9.514-9.394 1.135-.275 2.74-.316 3.876-.59z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M391.125 178.277c-1.958.538-2.808 2.191-2.984 3.733-7.221 5.056-1.974 15.017 4.725 12.946-4.955-7.42 0-11.612 5.51-9.01 1.67 1.225 2.835 3.78 2.993 3.623 1.048-2.274 5.198-4.255 5.198-4.255s3.342.45 3.944-1.71c.38-1.384 3.458-7.109 3.458-7.109-3.571-.733-7.142-1.466-10.71-2.203l-7.401-.157c-1.312.578-2.624 1.154-3.94 1.732-.522.839-.266 1.568-.793 2.41z"
      fill="#ffba00"
      fillRule="evenodd"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M433.328 337.504c4.894 2.936 7.138 5.684 10.149 9.443-1.323.391-1.774 2.575-2.515 3.007-2.35-4.74-6.236-8.773-10.345-12.807 1.136-.274 1.575.632 2.71.357z"
      fill="#d40000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M431.478 336.937c-4.894 2.936-6.6 4.804-9.615 8.563 1.45.09 3.236.988 3.98 1.42 3.64-4.736 6.459-6.42 9.51-9.397-1.134-.274-2.74-.312-3.875-.586z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M435.47 337.174c-4.89 2.935-6.95 5.864-9.965 9.623 2.425 1.736 1.835 1.845 2.335 2.823 2.349-4.737 7.514-8.65 11.626-12.683-1.135-.275-2.86.511-3.996.237z"
      fill="#d40000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M203.69 472.45a16.127 9.058 0 1 0-32.26 0 16.127 9.058 0 1 0 32.26 0h-16.13z"
      fill="#973000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.243}
      transform="matrix(.39048 .12757 -.1173 .4247 356.464 65.154)"
    />
    <path
      d="M427.52 331.01c-3.53 2.535-8.518 5.923-12.044 8.457-.725.62 2.444 1.266 3.605.699 3.725-2.556 5.684-4.231 9.409-6.788l2.127-1.189c-1.518-.109-1.578-1.07-3.097-1.178z"
      fill="#008d2b"
      fillRule="evenodd"
      stroke="#005e00"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M203.69 472.45a16.127 9.058 0 1 0-32.26 0 16.127 9.058 0 1 0 32.26 0h-16.13z"
      fill="#973000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.549}
      transform="matrix(.33155 -.13016 .15592 .34876 260.872 176.514)"
    />
    <path
      d="M463.497 291.952c.185-9.679 8.669-1.205 12.003-5.192 7.83-9.229 8.499-9.931 15.42-8.93 18.539 7.286-.813 24.134-19.762 16.462-2.082-1.144-5.582-1.196-7.66-2.34z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9878652000000001}
    />
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M533.421 260.056a2.478 2.001 21.536 1 0-4.754-1.351 2.478 2.001 21.536 1 0 4.754 1.35l-2.375-.674z" />
      <path d="m532.797 259.564 4.51 3.914-1.188 1.369-4.51-3.913z" />
    </g>
    <path d="m505.425 273.888.985 1.38 3.402-2.965-.985-1.38-3.402 2.965z" fill="#6d390b" fillRule="evenodd" />
    <path
      d="M420.089 297.711c5.755 1.762 9.983 22.667 15.618 24.546M425.607 297.594c5.755 1.762 9.867 22.667 15.502 24.545M431.008 297.36c5.755 1.761 9.984 22.783 15.623 24.662"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.4096250000000001}
    />
    <path
      d="M203.69 472.45a16.127 9.058 0 1 0-32.26 0 16.127 9.058 0 1 0 32.26 0h-16.13z"
      fill="#973000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.243}
      transform="matrix(.33155 -.13016 .15592 .34876 344.961 161.952)"
    />
    <path
      d="M508.132 278.687c.29 1.116-.21 2.564-2.177 3.071-1.962.508-3.808-.257-4.093-1.374-.29-1.116.85-2.721 2.812-3.228 1.962-.508 3.168.415 3.458 1.531z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.8976492}
    />
    <path
      d="M421.712 332.196c-2.91.59-9.547 2.029-12.442 7.83-.522 1.09-4.89 1.937-4.296.053.68-.984.924-1.071 1.608-2.06-.056-1.233-2.883-.868-2.687.237-.218-.049-1.587.215-2.23.88-1.736 2.214-4.698 2.116-4.593-.248 1.094-.808 1.65-1.587 2.2-2.78.36-1.294-2.17-1.757-2.99-.802-1.732.905-2.818 2.206-4.882 3.21-2.293.827-4.5-.647-2.5-1.831 1.797-.882.297-2.923-.579-2.989-1.515-.366-7.713.681-8.83.056-.876-.115-2.47-2.412-.601-2.822 1.695-.553 4.522.62 5.255-2.69.73-5.577 9.578 2.852 8.142.524-3.24-4.793 2.278-5.92 3.943-2.655.677 1.474 4.049 3.659 5.026 3.249 1.834.203-3.41-4.644.755-5.434.948.202 2.643.274 3.812 1.894.868.836 1.053 4.28 4.304 4.566.71-1.049.026-.514-.609-1.955-.004-1.744 2.883-1.602 4.116 1.35 1.222 2.255 7.669.724 13.567.86 1.89-.31 4.931 1.352-5.489 1.557z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#286026"
      strokeWidth={1.7385375}
    />
    <path
      d="M501.602 278.48c1.038 1.595 1.015 4.121-1.789 5.947s-6.09 1.598-7.127.004c-1.037-1.595-.101-4.702 2.703-6.528 2.804-1.826 5.176-1.017 6.213.578z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M503.61 271.87c.97.62 1.59 2.02.5 3.73s-2.962 2.406-3.932 1.786c-.974-.62-1.233-2.57-.143-4.28 1.09-1.709 2.601-1.856 3.575-1.236z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.8976492}
    />
    <path
      d="M506.564 274.77c.628.965.617 2.497-1.082 3.603-1.703 1.107-3.692.969-4.32.002-.63-.966-.063-2.85 1.636-3.956 1.699-1.106 3.139-.616 3.766.35z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.8976492}
    />
    <path
      d="M512.887 269.045c.474.727.462 1.88-.816 2.712-1.278.832-2.774.728-3.248.001-.473-.727-.048-2.144 1.23-2.977 1.281-.832 2.36-.463 2.834.264z"
      fill="#d90000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.6751164000000001}
    />
    <path
      d="M432.08 327.745c-2.5.294-3.925.448-4.406 2.258-.267 1.23-.052 2.835.158 4.215 0 1.584 2 2.632 4.33 3.083h4.004c1.688 0 4.808-1.65 4.808-3.234.248-.895.24-2.34.24-3.32 0-2.663-1.88-2.828-4.233-3.077l-4.901.075z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M521.018 296.28c-.275-9.246-2.71-22.644 8.638-27.24 1.466-.381 1.992.444 1.496 1.662-3.38 8.526-6.755 17.051-10.134 25.577z"
      fill="#008f00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5505875}
    />
    <path
      d="M535.685 277.453c2.019-3.8 7.01-4.757 8.774-4.64-3.485 3.563-6.97 12.293-8.924 15.15-2.82 4.855-11.04 8.3-15.972 11.158 5.518-7.517 10.6-14.152 16.122-21.668z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5505875}
    />
    <path
      d="M432.294 327.7s-2.507.445-2.56.445c-.056 0-1.95 1.224-1.95 1.224s-.388 2.394-.388 2.45.444 2.728.444 2.728l1.169 1.615 3.063 1.057.222-9.52z"
      fill="#009400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth=".3759pt"
    />
    <path
      d="M519.525 299.103c.331-.332 6.496-29.395 16.777-32.837 1.657 2.16.857 6.853.195 9.344-3.157 10.851-10.826 18.289-16.972 23.493z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5505875}
    />
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M542.215 263.34a2.001 2.478-75.081 1 1 4.626 1.738 2.001 2.478-75.081 1 1-4.626-1.738l2.311.868z" />
      <path d="m543.01 263.316-5.954.467.142 1.807 5.953-.467z" />
    </g>
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M517.124 293.094a2.68 2.17 45.48 1 0-4.284-3.167 2.68 2.17 45.48 1 0 4.284 3.167l-2.14-1.583z" />
      <path d="m516.675 292.353 3.115 5.728-1.687.975-3.115-5.728z" />
    </g>
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M524.524 301.109a2.17 2.68 76.333 1 0 4.916-2.053 2.17 2.68 76.333 1 0-4.916 2.053l2.456-1.026z" />
      <path d="m525.39 301.103-6.514-.264.028-1.948 6.515.264z" />
    </g>
    <path
      d="M515.056 307.764c6.315-3.423 2.357 1.379 1.966 4.007-1.868 6.487-3.613 6.529-5.804 7.634-3.274 2.985-13.758 1.537-18.633 2.768 6.108-4.435 16.363-9.975 22.47-14.41zM505.602 306.26c2.635-2.093 3.067-6.714 2.894-8.315-2.39 3.414-8.506 7.164-10.468 9.138-3.357 2.89-5.417 10.62-7.225 15.31 5.138-5.53 9.66-10.604 14.799-16.134z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.2615204}
    />
    <path
      d="M472.763 332.801c4.132-1.212 11.168 1.84 12.319 3.182-4.985-.001-13.06 3.461-16.472 4.059-5.44 1.376-20.532-7.138-25.937-8.354 9.021-.454 20.855 2.42 30.09 1.113z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.5505875}
    />
    <path
      d="M441.323 331.923c3.53 2.535 8.518 5.924 12.044 8.457.725.617-2.447 1.267-3.609.7-3.721-2.557-5.68-4.233-9.405-6.79-.71-.395-1.417-.792-2.127-1.188 1.518-.11 1.578-1.07 3.097-1.179z"
      fill="#00602b"
      fillRule="evenodd"
      stroke="#004500"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M490.28 322.178c.425-.16 17.24-22.863 27.693-21.924.628 2.492-1.913 6.232-3.477 8.126-7.033 8.152-16.739 11.648-24.216 13.798z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.4806701}
    />
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M488.216 318.84a2.68 2.17 73.589 1 0-2.287-4.811 2.68 2.17 73.589 1 0 2.287 4.812l-1.143-2.404z" />
      <path d="m488.168 317.975.049 6.52-1.947.066-.049-6.52z" />
    </g>
    <g fill="#6d390b" fillRule="evenodd">
      <path d="M492.61 328.153a2.17 2.68-73.065 1 0 5.276.735 2.17 2.68-73.065 1 0-5.277-.735l2.637.367z" />
      <path d="m493.358 328.59-5.473-3.544 1.016-1.662 5.473 3.543z" />
    </g>
    <path
      d="M349.953 245.702c.493-.733 1.628-1.218 3.045-.425 1.413.794 2.01 2.18 1.519 2.917-.493.733-2.083.955-3.5.166-1.413-.793-1.556-1.921-1.064-2.658z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7018053}
    />
    <path
      d="M469.88 329.768c6.943-1.837 6.53-5.18 9.777-8.105-7.514-1.1-13.502 1.56-16.712 3.324-5.067 3.269-6.38 6.817-10.77 9.261 7.485-.956 10.86-2.031 17.705-4.48z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.2615204}
    />
    <path
      d="M447.232 331.8c19.863 1.498 16.698-6.566 38.466-6.367-.323 2.55-4.477 5.748-6.623 6.945-9.518 5.032-25.16 7.393-31.843-.579z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.4806701}
    />
    <path
      d="m437.14 327.643.052 9.354 2.564-1.002s1.056-1.67 1.056-1.782.447-2.283.447-2.338-.225-2.673-.225-2.673l-1.948-1.28-1.947-.279z"
      fill="#d40000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth=".3759pt"
    />
    <path d="m354.45 240.79-3.179-3.492 1.081-.916 3.179 3.493z" fill="#6d390b" fillRule="evenodd" />
    <path
      d="M350.45 242.94c.54-.937 1.781-1.553 3.33-.542s2.203 2.782 1.665 3.721-2.282 1.222-3.83.21-1.703-2.45-1.166-3.39z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.8296112999999999}
    />
    <path
      d="M359.2 239.026c.906.034 1.887.838 1.835 2.658-.05 1.82-1.034 3.21-1.94 3.176-.906-.037-1.864-1.428-1.816-3.248.053-1.823 1.015-2.623 1.921-2.586z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7540553999999999}
    />
    <path
      d="M354.746 239.752c1.026-.271 2.364.188 2.845 1.992.482 1.808-.21 3.507-1.236 3.774-1.027.27-2.511-.77-2.996-2.579-.481-1.804.36-2.917 1.387-3.187z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.8266041}
    />
    <path
      d="M380.33 268.718c-3.094-7.875-11.548-20.945-20.156-14.645-9.552 8.24 4.356 21.206 16.22 20.472l3.936-5.827z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M355.75 245.638c1.653-1.112 4.307-1.139 6.277 1.752s1.793 6.319.14 7.431-4.936.196-6.906-2.695c-1.974-2.887-1.17-5.375.488-6.488z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9837303000000001}
    />
    <path
      d="M349.63 232.486c.755-.508 1.966-.52 2.864.8s.82 2.883.064 3.39-2.252.091-3.15-1.228-.53-2.455.222-2.962z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.706692}
    />
    <path
      d="M406.631 278.087c-3.894-6.923-14.51-15.58-25.328-10.042-12.792 8.978 5.161 22.425 23.531 15.794 1.647-1.707.147-4.045 1.797-5.752z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9878652000000001}
    />
    <path
      d="M442.691 282.181c-3.89-6.923-24.745-14.793-33.83-8.152-11.372 12.757 5.318 21.637 27.782 15.322 1.65-1.708 4.398-5.462 6.048-7.17z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9878652000000001}
    />
    <path
      d="M361.696 256.321c.113 0 2.338 2.786 2.338 2.786l-.112-3.898M365.594 261.778l2.338 2.338M373.834 260.22l.222 2.671 1.447-.111M373.834 269.127c-.556-.334-2.45-1.893-2.45-1.893M368.376 269.35l-3.116-1.002"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path d="m362.474 263.448-3.003-1.002" fill="none" stroke="#000" strokeWidth={0.9397500000000001} />
    <path
      d="M356.798 261.667h-2.563"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M368.823 253.205v-3.342"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".3759pt"
    />
    <path
      d="M364.369 271.243c-.335 0-4.676-.223-4.676-.223M372.165 274.25l-3.342 1.113M377.176 262.335c.109-.112 2.781-1.446 2.781-1.446M369.601 258.547c0-.11-.89-3.673-.89-3.673"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M432.023 327.69c-2.5.293-3.924.447-4.405 2.257-.267 1.23-.053 2.835.161 4.215.444 2.309 1.996 2.632 4.327 3.087h4.003c1.688 0 4.421-1.097 4.865-3.182.304-1.062.184-2.396.184-3.375-.222-2.441-1.88-2.828-4.233-3.077l-4.902.075zM432.298 327.693l-.08 9.289M437.18 327.693l-.078 9.289"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M537.659 248.24c1.47-4.83-3.616-5.974-4.748-8.684-2.323 4.541-1.507 9.168-1.097 11.604.95 3.95 4.454 6.68 5.037 10.018 1.022-4.98.86-8.037.808-12.939z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={0.8442714}
    />
    <path
      d="M544.387 243.755c.102-2.643 3.549-4.537 4.936-4.954-.86 5.142.688 7.555.278 9.664-.308 3.44-6.612 8.698-9.288 11.62 1.357-5.647 2.717-10.688 4.074-16.33z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.1220615}
    />
    <path
      d="M537.129 264.355c.165-.316-2.624-24.566 4.368-29.6 1.834 1.08 2.432 4.55 2.567 6.451.387 8.36.662 12.608-6.935 23.149z"
      fill="#008c00"
      fillRule="evenodd"
      stroke="#286326"
      strokeWidth={1.2010005}
    />
    <path
      d="M396.87 263.778c1.999.635 3.762 2.817 2.68 6.364s-2.756 5.828-5.387 5.036c-3.417-.792-4.03-3.96-2.951-7.508 1.082-3.546 3.657-4.526 5.657-3.892z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0389876}
    />
    <path
      d="M400.252 260.156c.636.443 1.015 1.38.24 2.44-.777 1.06-2.048 1.426-2.683.98-.635-.447-.76-1.723.015-2.781.774-1.06 1.793-1.087 2.428-.64zM394.993 259.065c.76-.157 1.703.2 1.948 1.489.248 1.29-.35 2.47-1.11 2.632-.759.16-1.777-.617-2.025-1.906-.249-1.29.424-2.053 1.187-2.215z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1908512}
    />
    <path
      d="M397.2 261.88c.744.223 1.402.993 1 2.242s-1.496 1.998-2.24 1.774c-.745-.223-1.264-1.395-.861-2.645.402-1.25 1.357-1.595 2.101-1.37z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1908512}
    />
    <path
      d="M398.279 257.411c.62.17 1.165.752.83 1.696-.334.947-1.247 1.51-1.868 1.342s-1.052-1.057-.718-2c.335-.947 1.132-1.207 1.756-1.038z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9461403}
    />
    <path
      d="M401.538 263.1c.68.468 1.06 1.357.169 2.247-.89.89-2.3 1.103-2.977.636-.68-.467-.767-1.64.124-2.532.89-.89 2.003-.818 2.684-.35z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.191603}
    />
    <path
      d="M392.99 261.152c.692-.083 1.503.327 1.616 1.53.113 1.203-.518 2.233-1.21 2.316s-1.538-.717-1.65-1.92c-.113-1.201.552-1.843 1.244-1.926z"
      fill="#dc0000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.0814643}
    />
    <path d="M382.63 323.69v-.11.11z" fill="none" stroke="#000" strokeWidth=".3759pt" />
    <path
      d="M472.436 277.124c3.895 2.078 2.56 6.94-.225 8.24-.147-3.192-2.188-4.157-5.233-4.9 1.598-.89 3.304-3.786 5.458-3.34z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M435.218 296.566c1.436-21.132 17.491-23.695 28.133-20.037 15.585 11.308-.218 20.703-23.547 21.313-2.078-1.144-2.503-.132-4.586-1.275z"
      fill="#008d00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9878652000000001}
    />
    <path
      d="M439.887 272.825c-4.984-.201-6.488 4.662-4.533 7.2 1.985-2.67 4.526-2.458 7.909-1.542-1.038-1.581-1.026-4.943-3.376-5.658z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9987663}
    />
    <path
      d="M442.488 279.149c-3.898 2.078-3.067 6.94-.282 8.24.147-3.192 2.188-4.157 5.233-4.9-1.598-.89-2.797-3.786-4.95-3.34z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M472.951 277.525c.045-1.74-1.327-3.242-2.935-3.485-1.94-.236-3.8 1.102-5.74-.315-.234-.157-4.74-4.045-6.03-5.856-1.293-.708-4.003-2.037-4.003-2.037-1.594 2.08-2.718 4.472-5.022 5.843-1.147.459-1.587.996-3.677.825-2.161-1.01-4.54-1.53-5.777-.432 1.052 2.083.767 4.718.323 6.722.778.445 1.635-.088 2.575.121 2.887.077 2.15 3.179 3.229 4.515 3.041.827 4.586-.63 5.03-3.11.804-1.265 3.262-1.429 5.01-1.906 1.891-.366 4.26-.968 5.992.006 1.436.76 2.395 1.68 3.12 3.229 0 0 2.282.203 4.564-.223.079-1.37-.203-3.865 3.341-3.897z"
      fill="#f6aa00"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M452.784 268.013c.038 1.67.075 3.34.11 5.011.593 1.819 4.642 1.633 5.123.446l-.113-5.68"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M454.119 278.704c.876-.296 1.199-2.725 1.199-2.725M457.682 278.035l.222-2.004M461.359 278.035l-.335-2.115M451.672 276.476c-.136.076-1.895-2.115-1.339-1.893M448.439 279.706c.225 0-2.906-3.243-2.35-3.02M445.544 273.692c-.078-.248-.221-1.447.335-1.225"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M452.525 272.947c-4.759 4.106-9.236 2.378-9.882 5.831M464.302 275.268c.165-.201.74-1.264.139-1.262"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M387.904 277.3c.06-.093 3.612-.387 3.612-.387l-3.293-2.083M409.552 280.848c.064-.092 3.616-.385 3.616-.385l-2.823-3.267M418.307 281.44c-.173-.565 3.732.088 3.616-.386l-2.466-2.674M413.634 268.98c.11 0 2.338 2.784 2.338 2.784l-.112-3.897M480.687 287.563c.087.072-.018 3.97-.018 3.97l2.556-2.774M452.145 286.557c.075.081-.428 3.61-.428 3.61l3.811-2.023M385.31 268.472l2.338 2.338M381.051 272.366l2.338 2.339M397 278.429l3.297-.294M391.768 281.685l3.297-.234M415.615 274.192l2.338 2.338M425.351 275.409l2.338 2.338M407.218 271.15l2.338 2.338M382.634 263.725l2.338 2.339M408.763 292.19l2.165-2.502M419.716 294.259l2.166-2.502M377.65 281.471l3.296-.294"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M383.886 279.125c-.538.03 1.669-.143 2.278.101l-3.256-2.327"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.0010217}
    />
    <path
      d="m387.994 286.096 3.297-.294M427.061 282.902l3.297-.234M421.464 287.527l3.297-.235M425.438 270.563c.112 0 2.338 2.783 2.338 2.783l-.11-3.897M457.532 280.52l-2.338 2.339M465.2 283.076l-2.338 2.338M461.79 289.648l-2.337 2.339M489.295 290.256l-2.338 2.339M474.816 288.553l-2.342 2.338M489.055 274.557l-2.338 2.338M500.118 290.365l-3.293-.313M472.47 297.702l.158-3.304M482.905 282.748l1.684-2.847M488.138 285.913l1.684-2.848M492.494 294.97c-.071.085-3.635-.027-3.635-.027l2.553 1.862M443.018 293.98c.076.082-.428 3.611-.428 3.611l3.812-2.023M413.683 287.526c.432-.323 2.639-1.008 2.519-1.482l-2.346-.849"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M512.985 265.254c1.545 1.2 4.15-12.447 3.751-16.718 0-.281-.485-9.333 1.41-15.802 1.199-2.18 1.24-18.498-.557-22.787 1.433-.12 3.166-.583 3.38-2.335-6.609 2.447-8.176-13.964-14.536-23.392-6.21-9.454-13.916-14.965-21.919-20.7.624-1.602 1.549-3.11 2.77-4.613-9.83 4.924-25.147-12.905-47.746-11.574-5.098.511-7.496.816-8.8 3.917-4.199.357-8.503 1.312-8.514 6.856.007 1.33 1.214 3.755 3.917 3.79 3.702 1.063 6.71.232 9.213 5.39.188 1.413.477 3.92.665 5.334 0 0-3.315-4.2-5.127-4.898.481-.7-.286-1.18 1.109-2.26-1.696-.98-4.733-.184-4.733-.184s-6.563-3.09-11.852-2.255c0-.564-1.011-4.282-1.011-4.282-.936 2.617-3 2.478-3.304 4.962-.564-1.785-1.327-3.973-1.895-5.762-1.853 2.537-1.315 5.27-1.973 7.905-.737.598-2.203.631-2.575-1.064-.188-2.071-.44-2.278-.429-4.747-1.342 2.334-2.947 3.473-3.488 7.503-.564-1.504-.86-2.944-1.428-4.447.07 5.24-4.451 8.386-8.733 12.066-1.203 2.23.188 2.26.282 3.387l2.26 1.131c1.315-.094 2.732-.188 4.048-.285.661.85.12.898 1.876 1.447 4.706 1.315 10.592-4.338 15.209 4.548-2.124 1.77-4.252 5.936-3.587 6.706.85 0-1.699 1.2 1.745.102-3.594 3.492-6.026 8.082-6.026 8.367-.402.978 1.447-.135 1.06 1.647.504-1.335.853-.11.853-.11-8.198 8.868-.274 18.378-1.157 23.498 1.364 2.196 1.533-.041 3.236-.285 1.443 6.285 5.567 10.096 8.108 15.08-1.312-.402-3.917-.544-5.33.053.12 2.365 2.26 4.613 3.954 6.68-1.225.376-2.353.752-3.574 1.132-2.542 1.315-4.23 2.698-6.019 4.672-1.191 2.88 5.692 3.579 8.988 4.063-.297 1.034-.718 2.335-.12 3.47 5.187.5 11.183-1.034 11.183-1.316 0-.285 1.3-1.01 1.3-1.01.7 1.398 2.233 1.807 2.918 1.608.98 0 2.503-3.906 1.804-6.898 1.88 2.256 3.65 5.85 5.533 8.108.568.6 1.304.16 1.774-.244 1.602 2.543 3.808 5.084 5.41 7.621.845.97.661.613 1.808.684 1.045-.338 1.936-.477 2.484-2.507 0 0 .346.315.842 1.434 1.263.898 2.154-1.262 2.853-1.96.399-.963 1.955.188 1.955-.376.564.376.936 2.03 1.5 2.406.865-.32 1.722-2.218 1.79-4.233.856 1.767 1.12 1.62 1.781 2.094.564-.474.74-2.316 1.304-2.786-.12-.973 6.778 6.654 7.06 6.654.684.496 4.582 1.691 5.383.297 1.947 1.3 7.183 2.105 8.033.015 4.315 1.842 9.39-.222 9.175-2.282 3.932 1.571 10.067.522 10.067.24.7-.082 2.594-1.924.797-3.319-13.078-9.128-32.538-24.24-40.026-27.874 0-2.695-2.041-12.412-4.236-15.093-.399-1.38.5-3.082 1.796-2.984 5.09 4.759 6.94 4.304 9.635 5.07 2.917 2.301 3.962 5.816 6.879 9.015 1.376.436 3 1.83 2.575.473-1.82-4.567-4.019-8.991-9.47-14.927 2.824 1.41 7.447 5.147 10.567 7.857 2.083 3.428 2.665 6.16 4.549 10.487 1.364.865 2.755 4.053 2.556 1.41-.297-4.97-3.786-12.863-3.786-13.427 5.541 4.42 5.485 11.273 7.158 15.464 1.447 2.128 2.172 4.955 2.774 4.293.695-.966-1.647-12.935-1.647-12.935-.376-1.503-.564-3.21-.94-4.713 4.124 2.375 5.568 11.435 7.496 22.287.008 1.729.71 3.623.616 4.751.888 1.094 1.906 4.112 1.857 2.312 0 0 .004-17.656-1.191-21.712-.3-2.161.53-5.699.53-5.699 1.503 7.338 3.109 15.273 4.616 22.61v5.365c.752.752 1.503 1.503 2.255 2.259.47-4.424.94-8.845 1.414-13.266 0 0-1.696-15.52-1.696-15.802v-4.519c-.033-1.59 1.429-1.285 2.391.519.192 3.857.177 6.917.365 10.773.661 4.417 1.12 7.642 1.477 13.262.177 4.605.353 15.496 1.33 15.308z"
      fill="#9c4314"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M439.88 290.78c-.21-.497-.365-2.8-.85-2.795l-1.376 2.083M481.15 278.212l-.282 2.33M460.622 295.396c-.538.065-2.79-.428-2.92.042l1.62 1.898"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M426.11 243.191v.244-.244.244-.244 4.26c.124.604.12 1.277.12 1.946.08.515.26 1.135.49 1.703.033.722.232 1.195.484 1.827.053.624.267 1.154.489 1.703.053.628.256.955.365 1.462.176.583.39.966.609 1.338.157.158.218.316.364.365"
      fill="none"
      stroke="#000"
      strokeWidth=".3759pt"
    />
    <path
      d="M416.615 258.16c0-.196-.03-.794.245-1.215.432-.612.778-.992 1.338-1.582.665-.425 1.139-.925 1.706-1.462.606-.388.91-.73 1.459-1.094.338-.346.73-.515 1.097-.733.418-.203.722-.508 1.339-.606.372-.187 1.139-.124 1.702-.124.58 0 .782-.112 1.339-.12"
      fill="none"
      stroke="#000"
      strokeWidth=".3759pt"
    />
    <path
      d="M505.087 215.882c1.88 1.365 3.95 4.33 4.797 9.69M494.51 217.709c2.728 2.447 4.266 5.108 6.303 11.1"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M487.92 220.633c1.661 1.899 2.665 3.887 3.574 6.255M476.631 214.424c2.162 2.495 5.643 6.303 7.432 10.16"
      fill="#00c600"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M430.681 150.761c.158 10.841 16.033 8.198 17.367 18.385 3.037 11.12 1.77 18.303-2.673 21.833-2.522 2.597-.59 6.638.158 8.71 4.128 10.457 10.356 12.14 13.033 21.162"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M424.746 158.163c0-.207.372-.572.74-.741 1.583-.515 2.553-.545 4.17-.647 1.386 0 2.683.06 4.074.279"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m445.296 257.7 5.519 8.979M462.885 244.345l29.545 22.627M462.1 250.551l21.587 18.955M421.472 227.042c2.845 5.646 10.878 13.142 15.701 14.337.166-3.623-.041-5.025-.62-7.536"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M430.621 223.829c2.842 5.646 5.44 11.66 12.98 15.08.782-5.48-.906-12.938-5.07-20.52"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M431.952 216.258c2.594 1.564 4.943 2.267 6.676 2.473.782-5.48 1.466-11.28-3.004-19.13"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M421.968 219.502c3.83 4.161 6.92 4.368 8.653 4.575 1.278-3.752 1.812-11.706.248-20.276M412.04 222.84c3.816 4.94 12.612 14.31 17.345 17.716.165-.786.41-1.15.345-3.661M477.203 168.605c4.086 4.71 19.859 20.57 22.982 27.99 5.39 12.134 15.33 14.438 17.807 13.08M450.176 234.158c1.42 5.804 4 16.363 7.713 18.032.639-.624 1.18-1.778 1.116-4.293"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M428.745 201.263c1.666 1.7 2.045 3.244 3.775 3.451 2.108-1.722 5.822-11.337 4.488-18.43"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M419.995 201c.785 3.82 1.514 7.044 4.22 7.075 4.493-3.76 5.82-12.168 4.485-19.265M418.254 221.205l-2.026-4.447M461.922 257.197l13.548 12.309M455.472 252.247l4.18 11.77M437.05 241.47c2.84 5.646 8.9 13.795 13.72 14.99.165-.781.075-1.462.01-3.973M429.712 240.338c2.845 5.642 11.201 14.84 16.02 17.536.166-.782.869-.932.805-3.443M450.521 256.224l6.037 10.011M443.3 231.102c2.598 1.568 5.32 2.88 7.052 3.086.263-6.104-1.864-15.945-6.232-23.482"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M413.258 199.098c-.77 2.887-.665 6.04 2.038 6.07 7.503-3.236 3.022-6.46 9.465-17.396M423.156 179.243c2.842 5.646 3.676 9.484 8.104 10.935.887-.402 3.094-10.379-4.386-18.48"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M432.268 183.95c1.462 1.698 3.6 2.104 5.334 2 1.695-3.384-1.929-12.97-6.695-17.928M474.165 176.134c3.572 5.022 19.232 22.554 25.945 28.155 1.507-.195 3.737 1.68 1.65-4.657"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M472.406 187.227c3.568 5.022 10.104 13.529 16.814 19.126 1.688.628 3.32.425 3.857-.011.575-.557.053-4.537.2-8.586"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M468.155 193.554c4.086 4.503 9.48 9.69 16.088 15.7 1.688.629 3.147.655 3.338-.01.162-.658.466-.493.098-4.541"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M462.452 201.64c4.086 4.502 7.823 7.825 11.53 8.652 1.789.215 2.728.24 2.92-.424.162-.662.053-3.812-.007-7.447M456.645 207.654c4.086 4.503 4.09 6.371 7.796 7.198 1.79.218 3.116-.019 3.44-.631.578-1.282.778-2.67.721-6.304"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M454.987 178.206c4.116.748 4.458-2.808 4.124-5.357-.406-3.191-2.665-4.59-5.338-3.917M452.705 192.306c1.94.751 4.376.702 5.263-1.52.718-1.69.447-5.833-2.225-5.164"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M455.607 185.57c3.703.229 4.049-1.463 3.917-3.598-.146-2.485-1.83-4.38-4.507-3.71"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M459.208 175.894c5.41-3.256 20.983 9.796 9.139 13.953"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M458.062 185.14c5.41-3.254 17.314 7.395 5.24 11.541"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M456.036 192.486c6.037.21 12.98 9.897 1.146 11.085"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M448.924 197.662c1.943.748 3.063 1.233 4.793-.26.684-.627 1.586-3.503-.967-5.096"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M398.38 185.953c2.041-2.635 7.03-4.315 8.74-.827M452.566 198.132c3.515 1.154 9.112 10.939-.285 11.935"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M448.082 153.877c4.056.767 6.1 7.32 9.333 7.823 5.913.883-.763-6.838-2.04-7.706"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M388.284 181.886c1.819.075 3.53-.26 4.68-2.414M406.316 200.67c1.007 1.883 3.604 1.13 5.75-.177 2.937-1.677.463-7.578 7.462-12.608M410.033 225.513c3.816 4.939 11.055 12.307 15.566 16.265.166-.782.895-1.18.835-3.695M425.453 241.443l8.675 12.055M443.548 238.537c1.418 5.8 7.064 14.991 10.777 16.66.64-.627 1.068-3.116 1.008-5.63M441.53 255.156l-.53 5.38M454.521 228.257c1.417 5.804 3.552 19.926 6.819 22.486.639-.624 1.958-12.356 1.898-14.87M450.134 227.858c1.929.23 3.053.222 4.56.207.267-6.105-2.38-13.277-6.748-20.814"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m460.885 212.788-.3 6.173"
      fill="#00c600"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M439.094 210.15c2.041.785 3.496 1.04 5.116.913 1.677-8.262-2.537-8.274-7.789-14.115"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M462.558 155.212c4.052.767 1.48 6.834 6.995 8.717 4.628 1.541 2.023-4.838.74-5.706"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M456.528 168.838c2.925-2.127 13.386.82 16.927 3.793 1.011.943 2.56 4.717-2.248 8.187M401.106 173.838c8.397-8.195 12.291-7.263 21.907-1.218 1.38.323 2.88.041 3.774-.485.485-1.18.023-2.376-.609-3.29-4.3-3.082-7.507-3.973-11.563-3.405M413.19 204.248c-1.886 2.782-3.431 8.837-.244 15.577.128.778.944 1.553.124 2.071-1.57.79-2.281 2.098-3.165 3.406M462.13 247.285c.06-10.21-1.433-18.356-5.508-25.73M444.488 207.53c1.35-.143 3.041.229 3.872-.173.402-1.493-.744-3.327-1.203-4.733.774-.086 1.722-.086 2.323-.26.346-1.289 0-3.097 0-4.645"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M394.046 178.461c.327-2.27 2.353-4.785 4.627-6.086 1.094-.609 1.824.124 2.312.365.61.974.245 2.8 0 3.53-.609 1.218-1.827 2.191-4.014 3.044-1.14-.488-1.786-.364-2.925-.853z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M413.522 221.787c.484.245 5.352 5.598 5.352 5.598h2.921l.244-8.154"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M421.43 206.09c-.973 3.202-.608 6.409 0 9.612"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m415.089 221.205 1.139-4.447M417.172 204.383c-1.459 2.68-1.876 7.078-1.117 10.27M456.957 222.178l-2.756.057"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M358.294 211.834c.387 1.191-.913.552-1.195.887-1.365.485-3.534-1.192-4.902-5.244.666-1.132 4.594-3.571 5.853-3.045 0 0 2.473.94 2.77 1.974-.473 1.503-2.608 5.597-2.526 5.428z"
      fill="#9f3000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m456.957 222.178.045-5.42M461.434 250.664l.774 13.23"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M358.204 212.296c2.669 2.51 6.86.827 7.53 6.958.285 3.428-4.575 10.292 0 16.487 1.62 2.38 5.815 4.954 5.815 4.954 2.191 2.447 2.856 6.8 4.285 10.198 3.018 4.511 7.18 5.496 10.484 4.383 0 0 10.863-4.86 10.863-4.954 0-.098-5.526-7.435-5.526-7.338 0 .094-6.194 5.24-6.288 5.24-.67-.097-4.29.286-5.624-4.289-.094-5.845-2.984-9.081-7.623-11.434-2.353-1.782-4.225-4.609-2.192-8.578 1.173-3.62 2.35-9.721-1.811-13.819-2.67-1.778-4.575-3.176-7.436-3.717-3.778 1.428-3.747 1.049-2.477 5.909z"
      fill="#238700"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M411.928 161.279c-1.463 2.676-1.327 4.281-1.087 6.958M404.515 174.447h3.406c.906-.027 1.296-.369 1.95-.854.437-.248.903-.62 1.339-.973.36-.26.793-.56 1.214-.73.692 0 1.233.05 1.827.245.552.23 1.003.56 1.462.85.455.183.865.244 1.579.244.744 0 1.522-.034 2.191.12.643.045 1.365.184 1.827.365.59.372.944.815 1.338 1.217.023.647.237 1.042.245 1.703 0 .568.064 1.335-.124 1.707 0 .699-.11 1.195-.24 1.703-.448.42-.61.744-1.219.853-.477.372-1.195.365-1.947.365h-1.947c-.425-.354-.936-.722-1.462-1.218-.282-.654-.467-.869-1.094-1.094a12.068 12.068 0 0 0-1.827-.124c-.594 0-1.09.041-1.459-.24-.338-.324-.823-.49-1.338-.61-.552-.158-1.203-.124-1.827-.124h-.973"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M407.68 175.54c.041.042.079.083.12.12-.274-.274-.176-.142.489.125.804.184 1.673.338 2.552.364.839 0 1.602.102 2.436.12.583 0 1.196.05 1.703-.12"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M415.469 173.593h-.124c.383 0 .15-.03-.365.61-.049.695-.2 1.078.124 1.702.395.132 1.068.429 1.338.73.391.281.365.533.365 1.217-.233.38-.444.688-.73 1.218-.153.384-.353.895-.488 1.338-.14.557-.237 1.087-.244 1.703v1.218M459.524 159.422c.136.26 2.47 4.92 5.368 1.962.429-.504.579-.868.579-1.725 0-.448-.06-.97-.17-1.339"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M389.291 253.122c1.406 1.955 3.954.948 4.47-.616-1.748.113-2.418-.921-3.034-2.5-.372.906-1.827 1.992-1.436 3.116z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5100963000000001}
    />
    <path
      d="M471.839 163.771c0 .09 2.473 2.364 6.213 2.364.902 0 5.188-1.082 6.556-2.988"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M477.019 165.962c.056.365.172 1.696.172 2.583-.01.936.215 1.722-.139 2.503-.387.997-.812 1.395-1.755 1.737-.767.346-.929.015-1.782.045M456.434 161.252c0 .057 2.64 6.323 3.507 6.958"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M391.005 251.98c1.402 1.954 3.955.947 4.466-.617-1.748.113-2.413-.917-3.03-2.5-.372.906-1.83 1.993-1.436 3.117z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5100963000000001}
    />
    <path
      d="M393.67 250.837c1.402 1.958 3.955.951 4.466-.617-1.748.113-2.413-.917-3.03-2.5-.376.907-1.83 1.993-1.436 3.117z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.5100963000000001}
    />
    <path
      d="M441.39 158.046h.862c2.732-.462 11.923 1.233 13.517 2.925M443.112 202.451c-.056-.056.128 1.053.072.996.338.339-.053-.917-.245-1.684-.285-.684-.342-1.135-.342-2.067v-.688M425.934 242.962v.244-.244.244-.996 5.01c.124.606.124 1.279.124 1.948.075.519.255 1.135.485 1.707.034.721.237 1.195.488 1.823.05.624.264 1.157.485 1.706.053.624.256.951.365 1.459.177.586.39.966.609 1.338.158.162.312.977.458 1.022"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M418.51 235.782v3.29c.158.804.188 1.657.364 2.431.068.696.237 1.29.365 1.948.06.65.838 2.958 1.098 3.53.285.537.714 1.097.973 1.458.485.15.884.323 1.459.364h1.706c.68-.131.917-.203 1.214-.729.166-.327.158-.556.369-.73M416.442 257.934c0-.2-.03-.797.245-1.218.428-.613.774-.992 1.338-1.583.665-.424 2.32-2.698 7.3-4.014.582 0 .785-.113 1.342-.124M417.032 246.89c.042.041 2.726 1.443 4.117 1.504"
      fill="none"
      stroke="#000"
      strokeOpacity={0.772}
      strokeWidth={0.9397500000000001}
    />
    <path d="M424.697 251.604h-.132.132c-.045 0-.086 0 0 0z" fill="none" stroke="#000" strokeWidth=".3759pt" />
    <path
      d="M423.502 251.472c-.399-.267-13.303-3.992-13.037-3.992.264 0-4.725 3.395-4.725 3.395l12.307 4.19 4.92-3.593h.535z"
      fill="#ffbc00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M411.172 247.382c.816-2.07.594-4.8-2.071-6.491-6.082-3.733-16.303-3.417-18.246.94-2.102-.283-3.17 1.413-3.481 3.104-5.424 1.474-.406 7.74.94 7.996 1.823.62 2.319.165 2.635-.433 1.015.252 2.406-.834 2.755-1.582 1.29.237 2.267.214 2.29-1.079 3.69 3.462 8.78 5.857 9.344 1.402 1.947-1.285 3.89-2.571 5.834-3.857z"
      fill="#f7b200"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M387.381 244.841c-.342 2.414 1.279 5.015 3.85 7.526M390.76 241.83c-.345 2.417.347 6.522 2.918 9.03M394.572 239.237c-2.36 1.984-1.07 8.12 1.5 10.626"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M400.888 189.084c5.446 7.217-2.173 15.186-8.83 19.784-7.845 6.172-12.086 18.205 1.755 18.941 5-.09 10.428-.533 13.48 3.38 3.056 3.917 3.169 11.145-4.526 15.78-.752-.665-1.876-2.65-2.71-3.255s-1.384.169-2.135-.497c-.267-2.48 3.793-6.176-.045-7.07-4.97.842-22.355.913-22.13-15.668.38-3.699 2.357-7.845 5.526-12.066 3.173-4.221 11.863-9.454 12.698-11.747 1.338-1.977-1.109-5.83-3.06-6.36-1.597-4.26 5.454-8.804 9.977-1.222z"
      fill="#288800"
      fillRule="evenodd"
      stroke="#000100"
      strokeLinejoin="round"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m388.784 201.853.188 9.691M383.705 205.71l10.349 1.508M391.325 199.692l8.747 1.786"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m382.115 207.398 7.281 4.315M376.924 216.51l5.691 6.044M382.179 207.796l.966 14.292M378.255 213.784l9.348.188"
      fill="none"
      stroke="#000"
      strokeOpacity={0.642}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M368.477 237.925c1.448-1.369 2.959-3.338 3.895-5.263M371.406 240.387c1.954-1.21 4.462-2.162 6.95-2.669M374.996 248.702c1.695-1.414 3.518-2.91 4.766-4.88M375.063 249.025c2.981-.071 6.007-.38 8.947-.92M380.386 254.885c2.218-.834 4.244-2.116 5.887-3.398M364.952 234.933c1.721-1.387 3.443-2.97 4.841-4.613M363.688 230.478c1.872-.504 3.7-1.455 5.29-2.338M364.343 225.84c1.514-.587 3.281-.831 4.92-.929M365.752 221.566c1.83-.18 3.06-.072 4.89.503M366.057 218.848c1.515-.812 3.214-1.342 4.916-1.117M365.305 216.84l5.27-3.597M364.373 215.352l4.488-4.45M363.098 214.736l3.29-5.62M376.221 181.525l-.041 8.006M384.322 182.803c-1.18 2.304-2.835 5.033-4.958 7.07M378.345 181.254c-2.353-.188-4.575 1.086-6.36 2.594"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M390.881 187.366c3.91 1.436 9.097 3.413 8.556 14.893 3.236-3.507 4.717-8.424.609-14.626-2.763-2.985-6.808-3.616-9.165-.267z"
      fill="#9d4600"
      fillOpacity={0.994}
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth=".3759pt"
    />
    <path
      d="M392.644 191.193c.158-2.222 3.267-4.973 4.91-5.578M393.84 193.204c.819-2.842 4.364-5.097 6.003-5.702M393.915 197.234c1.514.022 7.243-3.154 8.551-5.045M394.384 195.114c1.842-1.279 5.3-4.177 6.94-4.786M399.44 197.433c1.38-.782 1.854-.59 3.297-2.079"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M390.881 187.434c3.932 1.278 8.736 4.176 8.424 14.822"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="m377.796 228.572 5.35-6.484M378.461 229.907l4.782-.004M375.796 223.426l6.684 3.808"
      fill="none"
      stroke="#000"
      strokeOpacity={0.642}
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M384.795 222.78c-1.282-.12-2.015-.365-3.127-.775.522 8.612 1.383 9.056 2.744 12.304 4.075 2.582 11.123 1.98 14.104 1.334.323.451 2.086 2.639 1 3.278-1.17.733-1.643 2.154-1.685 4.45.688.779 1.41.102 2.113.602s1.53 2.274 2.18 3.797 8.661-5.955 7.259-11.556c-.925-5.258-4.48-7.051-4.48-7.051-5.03-2.515-12.097-.846-14.676-1.809-3.21-.714-5.229-3.488-5.432-4.574z"
      fill="#9d4600"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth=".3759pt"
    />
    <path
      d="M399.064 237.977c4.338-1.98 8.928-2.142 10.172-1.962M382.096 226.471c.944-.552 2.33-1.729 3.925-1.703M390.077 235.959c.77-4.564 2.725-7.642 3.732-8.417M392.682 236.316c.77-4.564 2.905-7.823 3.913-8.593M395.587 236.019c.77-4.563 2.726-7.526 3.733-8.296M397.779 235.662c.77-4.564 3.319-6.811 4.326-7.586M399.237 236.955c.77-4.563 4.646-7.097 5.654-7.871M399.358 237.665c2.642-3.8 6.984-5.646 8.224-5.913M387.348 235.369c.77-4.564 2.785-7.052 3.792-7.827M384.743 234.538c.77-4.564 3.138-6.875 4.146-7.646M398.279 243.913c2.048-1.613 3.44 3.59 3.54 4.221s.486 1.275 1.504 1.865M383.141 231.395c.831-2.311 2.665-4.856 3.673-5.627"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M394.37 239.447c-2.658 4.222.41 7.95 3.849 6.454-.395-2.917-1.14-4.77 1.522-7.578-1.887.113-3.582-.556-5.372 1.124z"
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.9987663}
    />
    <path
      d="m384.344 208.405 1.26 6.203M385.603 214.104l-2.262 7.627M398.97 238.376c4.68-.91 9.18 0 10.345.47"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path d="M398.418 239.124c4.796-.072 8.98 1.89 10.014 2.661" fill="none" stroke="#000" strokeWidth={1.0107951} />
    <path
      d="M398.467 240.015c4.616 1.049 6.683 3.39 7.491 4.379M398.147 241.079c4.143 2.293 5.075 4.172 5.575 5.349"
      fill="none"
      stroke="#000"
      strokeWidth={1.0040289}
    />
    <path
      d="m329.635 263.263 2.223-.522 2.412 10.285-2.224.521zM348.13 298.014l4.669 5.317 1.74-1.475-4.383-5.507-2.026 1.665zM490.645 320.73l-5.785 4.076 1.282 1.89 5.943-3.77-1.44-2.195zM521.16 295.29l-5.157 4.841 1.53 1.694 5.36-4.562-1.732-1.974zM537.52 261.13l-1.876 4.634 1.026 1.328 2.019-4.408-1.17-1.553z"
      fill="#296526"
      fillRule="evenodd"
    />
    <path
      d="M384.679 234.79c-2.508-4.128-2.827-8.44-2.951-12.66 1.33.635 2.38.984 3.139.763M375.95 181.284c-2.063-5.157.32-7.954 2.895-10.405"
      fill="none"
      stroke="#000"
      strokeWidth={0.9397500000000001}
    />
    <path
      d="M379.313 169.443a1.851 1.266-44.885 1 0-2.755 2.463 1.851 1.266-44.885 1 0 2.755-2.463l-1.378 1.232z"
      fillRule="evenodd"
    />
    <path
      d="M365.951 208.721c-.432 0-7.905-1.007-7.905-1.007M362.79 214.183c0-.286-4.89-6.323-4.89-6.323"
      fill="none"
      stroke="#000"
      strokeWidth={1.221675}
    />
    <path d="M0 0h290.69v496.06H0z" fill="#0b7226" fillRule="evenodd" />
    <path d="M579.09 0h289.02v496.06H579.09z" fill="#bc0000" fillRule="evenodd" />
  </svg>
);

export default SvgComponent;
